import { _get, _put } from "../../../../http";

// porcentaje de ganancia corporativo
export const getPorcentajeDeGananciaCorporativo = (corporativoId) =>
  _get(`/corporativos/${corporativoId}/porcentajeDeGanancia`);

export const putPorcentajeDeGananciaCorporativo = (corporativoId, body) =>
  _put(`/corporativos/${corporativoId}/porcentajeDeGanancia`, body);
